const admissionStatus = [
  'BACKOFFICE_WAITING',
  'BACKOFFICE_DOING',
  'BACKOFFICE_DONE',
  'BACKOFFICE_PENDING',
  'CHECK_IN_DONE',
  'ADMISSION_WAITING',
  'ADMISSION_DOING',
  'ADMISSION_DONE',
  'CONFERENCE_WAITING',
  'CONFERENCE_DOING',
  'CONFERENCE_DONE',
  'CANCELED',
  'LEGACY_EXPORTED',
];

const allowedAdmissionStatus = [
  {
    priority: 0,
    status: 'CHECK_IN_DONE',
  },
  {
    priority: 1,
    status: 'ADMISSION_DONE',
  },
  {
    priority: 2,
    status: 'ADMISSION_WAITING',
  },
  {
    priority: 3,
    status: 'BACKOFFICE_DOING',
  },
  {
    priority: 4,
    status: 'BACKOFFICE_WAITING',
  },
  {
    priority: 5,
    status: 'BACKOFFICE_PENDING',
  },
  {
    priority: 6,
    status: 'CHECK_IN_WAITING',
  },
];

export {
  admissionStatus,
  allowedAdmissionStatus,
};
